import { useCopilotContext } from '@customerio/hydra-copilot/react';

/**
 * Adds global configuration to the Copilot context.
 */
export function GlobalCopilotConfiguration() {
  useCopilotContext({
    description: 'The current URL',
    value: window.location.href,
  });

  useCopilotContext({
    description: 'The current timezone',
    value: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  useCopilotContext({
    description: 'The current time',
    value: () => new Date().toISOString(),
  });

  return null;
}
